import React from 'react';
import { FadeIn } from './FadeIn';
export function Content() {
  return <section className="py-24 md:py-32 px-6 bg-cream text-charcoal border-t border-charcoal/5" data-id="element-55">
      <div className="max-w-4xl mx-auto" data-id="element-56">
        <FadeIn data-id="element-57">
          <div className="flex items-center gap-4 mb-12" data-id="element-58">
            <span className="text-3xl" data-id="element-59">📘</span>
            <h2 className="text-sm tracking-widest uppercase text-terracotta font-semibold" data-id="element-60">
              Contenido Completo
            </h2>
          </div>

          <div className="bg-white border border-charcoal/10 p-8 md:p-16" data-id="element-61">
            <h3 className="text-3xl md:text-4xl font-serif mb-6" data-id="element-62">
              FASE 1: <span className="italic" data-id="element-63">La Evaluación de Identidad</span>
            </h3>
            <p className="text-lg md:text-xl text-charcoal/70 mb-10 leading-relaxed" data-id="element-64">
              Tu hoja de ruta para entender la física de tu mente. Aprendé a
              diagnosticar tu nivel de desorganización emocional antes de que se
              convierta en una crisis.
            </p>

            <ul className="space-y-6" data-id="element-65">
              {['Detección precisa del caos mental.', 'Identificación de conductas que aumentan tu ansiedad.', 'Corte definitivo de los bucles de rumiación.'].map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-66">
                  <span className="text-terracotta mt-1.5" data-id="element-67">—</span>
                  <span className="text-lg md:text-xl font-medium" data-id="element-68">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}